import { Routes } from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';

import {permissions }                  from './../../permissions';
import {ConsoleApplicationsComponent }           from './console-applications.component';
import {ConsoleApplicationsEditComponent}         from './console-applications-edit/console-applications-edit.component';
import {ConsoleApplicationsCreateComponent}       from "./console-applications-create/console-applications-create.component";
import {AuthGuardService as AuthGuard} from './../../auth-guard.service';
export const routes: Routes = [
    {
        path: 'console-applications',
        component: ConsoleApplicationsComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'Console Applications',
            permissions: {
                only: [permissions.CONSOLE_APPLICATIONS_READ]
            }
        },
    }
    ,{
        path: 'console-applications/create/:id',
        component: ConsoleApplicationsCreateComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'Create Console Application',
            permissions: {
                only: [permissions.CONSOLE_APPLICATIONS_CREATE]
            }
        }
    },
    {
        path: 'console-applications/edit/:id',
        component: ConsoleApplicationsEditComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'Edit Console Application',
            permissions: {
                only: [permissions.CONSOLE_APPLICATIONS_EDIT]
            }
        }
    }
];


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/console-applications/console-applications.routing.ts